import styled, { keyframes } from "styled-components";

const enterAnimation = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`;

export const Container = styled.div`
  animation: ${enterAnimation} 300ms;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
  overflow: hidden;
  @media (max-width: 1200px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Section = styled.section`
  padding-left: 5px;
  width: 60.41%;
  height: 100%;
  display: flex;
  padding-top: calc(0.245 * 100vh);
  align-items: flex-start;
  flex-direction: column;
  padding-left: 10.7rem;
  padding-bottom: 7%;
  @media (max-width: 1200px) {
    text-align: center;
    margin: 0 0 8rem 0;
    width: 100%;
    padding-left: 0;
  }

  p {
    font-family: "Galano";
    line-height: 2.1rem;
    font-size: calc(1.6rem * var(--font-size-scale));
    font-weight: 800;
    font-style: normal;
    color: black;
    margin-bottom: 2.5rem;
    margin-right: 7.9rem;
    @media (max-width: 1200px) {
      color: #565656;
      margin: 0 0 2.5rem 0;
      width: 100%;
      font-size: 1.4rem;
      line-height: 2rem;
      text-align: left;
    }

    & + p {
      color: black;
      font-family: "Galano";
      line-height: 2.2rem;
      font-size: calc(1.7rem * var(--font-size-scale));
      font-weight: 400;
      font-style: normal;
      @media (max-width: 1200px) {
        width: 100%;
        line-height: 2.6rem;
        font-size: 1.8rem;
      }
    }
  }

  input {
    width: 90%;
    border: 1px solid black;
    font-family: "Galano";
    line-height: 2.1rem;
    font-size: calc(1.6rem * var(--font-size-scale));
    font-weight: 800;
    font-style: normal;
    padding-bottom: 1rem;
    outline: none;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 0.1rem solid #cdcdcd;

    &::placeholder {
      font-weight: 400;
    }
  }
  @media (max-width: 1200px) {
    width: 80%;
    padding-top: 3rem;
    margin: 0;
    display: flex;
  }
`;

export const Buttons = styled.div`
  display: flex;
  @media (max-width: 1200px) {
    width: 100%;
    justify-content: space-between;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    button{
      width: 100%;
      margin-bottom: 1.5rem;
      flex-flow: row-reverse nowrap;
      height: auto;
      padding: 1.5rem 0;
      justify-content: space-between;
      img{
        max-width: 50px;
        margin-right: 2rem
      }
      span{
        text-align: left;
        padding: 0 2rem;
        width: auto;
        font-size: 12px;
      }
    }
  }
`;

export const NavigateButtons = styled.div`
  width: 100%;
  position: absolute;
  bottom: 2rem;
  display: flex;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 4rem;
  @media (max-width: 1200px) {
    position: fixed;
    bottom: 0;
    padding: 2rem 10%;
    background: transparent linear-gradient(0deg, #ffffff 0%, #ffffff00 100%) 0%
      0% no-repeat padding-box;
  }
`;
